const BrandStatusTypes = {
    inactive: 0,
    active: 1,
} as const;

const AllowedImageMimeTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
    'image/svg+xml',
    'image/x-icon',
    'image/vnd.microsoft.icon',
] as const;

export { BrandStatusTypes, AllowedImageMimeTypes };
